export default function DSA_Huffman_Coding() {
  return <div>DSA_Huffman_Coding Component</div>;
}
